'use client';

import { useStore } from 'zustand';

import { useSearchParams } from '@/hooks/use-search-params.hook';
import { userLocationStore } from '@/store/user-location.store';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';
import { resolveCitySlug } from '@/utils/formatters/city/resolve-city-slug.util';

export function useSearchCitySlug(): string | undefined {
  const userLocation = useStore(userLocationStore, (state) => state.userLocation);
  const { getParam } = useSearchParams([PersistedUserNavigationSearchParams.CIDADE]);

  return resolveCitySlug(getParam(PersistedUserNavigationSearchParams.CIDADE), userLocation);
}
